import React from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import SideNav from '../../shared/Sidenav';
import '../../../css/TransactionFees/TransactionFees.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import add from '../../../assets/images/add.svg';
import addDisable from '../../../assets/images/plus_disable.svg';
import Calendar from 'react-calendar';
import viewAccess from '../../../assets/images/viewOnlyAccess.svg';
import SuccessModal from '../../shared/SuccessModal';
import AlertModal from '../../shared/AlertModal';
import DeleteModal from '../../shared/DeleteRoleModal';
import message from '../../../data/Message.json';
import TitleDescription from '../../../data/TitleDescription.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { serviceBaseURL } from '../../../Services/config/apiGateway';
import { TRANSACTIONFEES_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { success } from '../../../redux/_actions/serviceType.actions';
import { store } from '../../../redux/_helpers/store';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()
let viewOnly = false;
class ServiceType extends React.Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            addNewRow: false,
            showFromCalendar: false,
            showToCalendar: false,
            fromCalendar: '',
            toCalendar: '',
            showEditFromCalendar: [],
            showEditToCalendar: [],
            editIndex: '',
            editableIndex: [],
            deleteIndex: '',
            isEdit: [],
            isDelete: [],
            transactionFeesData: [],
            putTransactionFeesData : [],
            AmountExcludingVAT: '',
            renderEffectiveCalendar: false,
            renderExpiryCalendar: false,
            confirmedHasOpen: false,
            serviceTypeDropdown: false,
            defaultAmountEdit: false,
            showTransactionFeesActive: false,
            hasOpenAlert: false,
            serviceTypeValue: '',
            ExcludingVAT: '',
            vatRate: '',
            hasOpenDelete: false,
            serviceTypeData: [],
            feesListData: [],
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.onAddNewRow = this.onAddNewRow.bind(this);
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({
                showFromCalendar: false, showToCalendar: false,
                serviceTypeDropdown: false,
            });
            let editableIndex = this.state.editableIndex.filter((element, i) => i === this.state.editableIndex.indexOf(element))
            for (let index = 0; index < editableIndex.length; index++) {
                const element = editableIndex[index];
                let a = this.state.showEditFromCalendar;
                a[element] = false
                this.setState({ showEditFromCalendar: a })
                let b = this.state.showEditToCalendar;
                b[element] = false
                this.setState({ showEditToCalendar: b })
            }
        }
    };
    toggleServiceTypeDropdown = () => {
        this.setState({ serviceTypeDropdown: !this.state.serviceTypeDropdown });
    };
    changeServiceType = (event) => {
        // const found = Servicedata.find((serviceType) => {
        //     if (serviceType.serviceType === event.target.innerText) {
        //         return serviceType
        //     }
        // })
        const found = this.state.serviceTypeData.find((serviceType) => {
            if (serviceType.service === event.target.innerText) {
                return serviceType
            }
            return false;
        })
        this.setState({ serviceTypeValue: found.service });
        this.setState({ serviceTypeDropdown: !this.state.serviceTypeDropdown });
        store.dispatch(success(found.service))
        ApiCall(
            'GET',
            serviceBaseURL + TRANSACTIONFEES_ENDPOINT,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(data => {
            if (data.flag !== -1) {
                if (data.flag === 500) {
                    toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                }
                else {
                    console.log('I am 200!');
                    data = data.filter(x => x.service === found.service)
                    this.setState({
                        transactionFeesData: data,
                        putTransactionFeesData : data,
                        // ExcludingVAT: data[0].amountExVat,
                        ExcludingVAT: data[0]?.feesList !== null ? data[0]?.feesList.filter(defaultData=>(defaultData.status === "Active" && defaultData.feesType === "Default")).map(x=>x.amountExVat)[0] : 0,
                        vatRate: data[0].vatRate,
                        feesListData: data[0].feesList
                    })
                    // this.setState({
                    //     transactionFeesData: data,
                    //     ExcludingVAT: data.amountExVat,
                    //     vatRate: data.vatRate
                    // })
                }
            }
            else {
                //  toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }
        })
    }
    onAddNewRow() {
        this.setState({ addNewRow: true });
        document.getElementById('transactionFeesFunctionTable').scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
    handleAddFromDateChanged = (e) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        let formatted_date = e.getDate() + "-" + months[e.getMonth()] + "-" + e.getFullYear();
        if (e.getDate() <= 9) {
            formatted_date = "0" + formatted_date;
        }
        this.setState({ fromCalendar: formatted_date, showFromCalendar: false })
    }
    handleAddToDateChanged = (e) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        let formatted_date = e.getDate() + "-" + months[e.getMonth()] + "-" + e.getFullYear();
        if (e.getDate() <= 9) {
            formatted_date = "0" + formatted_date;
        }
        this.setState({ toCalendar: formatted_date, showToCalendar: false })
    }
    toggleFromCalendar = () => {
        this.setState({
            showFromCalendar: true,
            renderEffectiveCalendar: true
        });
    };
    toggleToCalendar = () => {
        this.setState({
            showToCalendar: !this.state.showToCalendar,
            renderExpiryCalendar: true
        });
    };
    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
        var selectedTiles = [];
        let roleData = this.props.data;
        const roleDataLength = roleData.length;
        for (let z = 0; z < roleDataLength; z++) {
            var rd = roleData[z].permissions;
            selectedTiles.push(rd)
        }
        selectedTiles.map(x =>
            x.map(md => {
                if (md.functionId === 18) {
                    if (md.method.includes("View & Edit")) {
                        viewOnly = true
                    }
                }
                return true;
            }))
        this.setState({ serviceTypeValue: this.props.serviceType })
        ApiCall(
            'GET',
            serviceBaseURL + TRANSACTIONFEES_ENDPOINT,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(data => {
            if (data.flag !== -1) {
                if (data.flag === 500) {
                    toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                }
                else {
                    console.log('I am 200!');
                    // console.log(data.filter(x=>x.service == this.props.serviceType))
                    // console.log(Object.values(data).filter(x => x.service == this.props.serviceType))
                    this.setState({serviceTypeData: data})
                    data = data.filter(x => x.service === this.props.serviceType)
                    // console.log(data,data[0].feesList.filter(defaultData=>(defaultData.status !== "Active" && defaultData.feesType == "Default")).map(x=>x.amountExVat)[0])
                    this.setState({
                        transactionFeesData: data,
                        putTransactionFeesData : data,
                        ExcludingVAT: data[0]?.feesList !== null ? data[0]?.feesList.filter(defaultData=>(defaultData.status === "Active" && defaultData.feesType === "Default")).map(x=>x.amountExVat)[0] : 0,
                        vatRate: data[0].vatRate,
                        feesListData: data[0].feesList
                    })
                }
            }
            else {
                // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }
        })
    }
    handleAmountExcludingVAT = (e) => {
        let value = e.target.value;
        value = value.replace(/[^0-9\.]/gi, "");
        this.setState({ AmountExcludingVAT: value })
    }
    handleDefaultExcludingVATAmount = (e) => {
        let value = e.target.value;
        value = value.replace(/[^0-9\.]/gi, "");
        this.setState({ ExcludingVAT: value })
    }
    validateFormFields = () => {
        let validEdit = [];
        let indexOfedits = [];
        this.state.isEdit.find((edit, index) => {
            console.log(edit)
            if (edit === true) {
                indexOfedits = indexOfedits.concat(index);
            }
            return false;
        });
        for (let i = 0; i < indexOfedits.length; i++) {
            // validEdit = validEdit.concat(this.state.transactionFeesData.feesList[indexOfedits[i]].amountExVat !== '');
            validEdit = validEdit.concat(this.state.feesListData[indexOfedits[i]].amountExVat !== '');
        }
        return (this.state.fromCalendar.length > 0 && this.state.toCalendar.length > 0 && this.state.AmountExcludingVAT) || (this.state.isEdit.includes(true) && !validEdit.includes(false)) || (this.state.ExcludingVAT !== '' && this.state.defaultAmountEdit);
    };
    handleValidation() {
        let errors = {};
        let formIsValid = true;
        if (new Date(this.state.fromCalendar).getFullYear() > new Date(this.state.toCalendar).getFullYear()) {
            formIsValid = false;
            toast(message.validation.date, { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
        }
        if (new Date(this.state.fromCalendar).getFullYear() === new Date(this.state.toCalendar).getFullYear()) {
            if (new Date(this.state.fromCalendar).getMonth() > new Date(this.state.toCalendar).getMonth()) {
                formIsValid = false;
                toast(message.validation.date, { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
            }
        }
        if (new Date(this.state.fromCalendar).getFullYear() === new Date(this.state.toCalendar).getFullYear()) {
            if (new Date(this.state.fromCalendar).getMonth() === new Date(this.state.toCalendar).getMonth()) {
                if (new Date(this.state.fromCalendar).getDate() > new Date(this.state.toCalendar).getDate()) {
                    formIsValid = false;
                    toast(message.validation.date, { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
                }
            }
        }
        if (new Date(this.state.fromCalendar).getTime() === new Date(this.state.toCalendar).getTime()) {
            formIsValid = false;
            toast(message.alert.dateIntervalVerifed, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    handleEditValidation() {
        let errors = {};
        let formIsValid = true;
        let editableIndex = this.state.editableIndex.filter((element, i) => i === this.state.editableIndex.indexOf(element))
        for (let index = 0; index < editableIndex.length; index++) {
            const element = editableIndex[index];
            // let fromDateParts = this.state.transactionFeesData.feesList[element].effectiveDate.split("/");
            let fromDateParts = this.state.feesListData[element].effectiveDate.split("/");
            let fromDateFormate = new Date(fromDateParts[2], fromDateParts[1] - 1, fromDateParts[0]).toString();
            // let toDateParts = this.state.transactionFeesData.feesList[element].expiryDate.split("/");
            let toDateParts = this.state.feesListData[element].expiryDate.split("/");
            let toDateFormate = new Date(toDateParts[2], toDateParts[1] - 1, toDateParts[0]).toString();
            let toDate = new Date(toDateFormate).getDate()
            let fromDate = (new Date(fromDateFormate)).getDate()
            let toMonth = (new Date(toDateFormate)).getMonth()
            let fromMonth = (new Date(fromDateFormate)).getMonth()
            let toYear = (new Date(toDateFormate)).getFullYear()
            let fromYear = (new Date(fromDateFormate)).getFullYear()
            let toTime = new Date(toDateFormate).getTime()
            let fromTime = (new Date(fromDateFormate)).getTime()

            if (this.state.isEdit[element]) {
                if (fromYear > toYear) {
                    formIsValid = false;
                    toast(message.validation.date, { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
                }
                else if (fromYear === toYear) {
                    if (fromMonth > toMonth) {
                        formIsValid = false;
                        toast(message.validation.date, { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
                    }
                    else if (fromMonth === toMonth) {
                        if (fromDate > toDate) {
                            formIsValid = false;
                            toast(message.validation.date, { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
                        }
                    }
                }
                if (fromTime === toTime) {
                    formIsValid = false;
                    toast(message.alert.dateIntervalVerifed, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                }
            }
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    updatedData = () => {
        let data = [];
        let editableIndex = this.state.editableIndex.filter((element, i) => i === this.state.editableIndex.indexOf(element))
        for (let index = 0; index < editableIndex.length; index++) {
            const element = editableIndex[index];
            if (this.state.isEdit[element]) {
                data.push(
                    this.state.feesListData[element]
                    // this.state.transactionFeesData.feesList[element]
                )
            }
        }
        return data;
    }
    onConfirmTransactionFees = () => {
        if (this.state.isEdit.length > 0) {
            console.log("tfeeUp",this.updatedData());
         
            console.log("tfeeser",this.state.transactionFeesData);
            console.log("tfee put data", this.state.putTransactionFeesData);
            if (this.handleEditValidation()) {
                ApiCall(
                    'PUT',
                    serviceBaseURL + TRANSACTIONFEES_ENDPOINT,
                    {
                        // "amountExVat": this.state.transactionFeesData.amountExVat,
                        // "amountInVat": this.state.transactionFeesData.amountInVat,
                        "feesList": this.updatedData(),
                        "service": this.state.putTransactionFeesData[0].service,
                        "serviceId": this.state.putTransactionFeesData[0].serviceId,
                        "vatRate": this.state.putTransactionFeesData[0].vatRate
                    },
                    {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'x-cc-trace-id': '1234',
                    }
                ).then(data => {
                    if (data.flag !== -1) {
                        if (data.flag === 500) {
                            if (data.data.message === "Time period Overlapping") {
                                this.setState({ hasOpenAlert: true })
                            }
                            else {
                                toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                            }
                        }
                        else {
                            console.log('I am 200!');
                            this.setState({ confirmedHasOpen: true });
                        }
                    }
                    else {
                        // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
                    }
                })
            }
        }
        else if(this.state.defaultAmountEdit){
            console.log("tfeepost2",this.state.transactionFeesData);
           let fromTimeStamp = new Date()
                fromTimeStamp = (new Intl.DateTimeFormat(['ban', 'id'], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(fromTimeStamp).toString().substring(0, 10));
            ApiCall(
                'POST',
                serviceBaseURL + TRANSACTIONFEES_ENDPOINT,
                {
                    "feesList": [
                      {
                        "amountExVat":  this.state.ExcludingVAT,
                        "amountInVat": ((Number(this.state.ExcludingVAT) + (this.state.ExcludingVAT * this.state.vatRate / 100)).toFixed(2)),
                        "effectiveDate": fromTimeStamp,
                        "expiryDate": fromTimeStamp,
                        "feesType": "Default",
                        "status": "Active",
                        "transFeesId": 0
                      }
                    ],
                    "service": this.state.transactionFeesData[0].service,
                    "serviceId": this.state.transactionFeesData[0].serviceId,
                    "vatRate": this.state.vatRate
                  },
                {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'x-cc-trace-id': '1234',

                }
            ).then(data => {
                if (data.flag !== -1) {
                    if (data.flag === 500) {
                        if (data.data.message === "Time period Overlapping") {
                            this.setState({ hasOpenAlert: true })
                        }
                        else {
                            toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                        }
                    }
                    else {
                        console.log('I am 200!');
                        this.setState({ confirmedHasOpen: true });
                    }
                }
                else {
                    // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
                }
            })
        }
        else {
            let fromTimeStamp;
            let toTimeStamp;
            if (this.state.fromCalendar.length > 0 && this.state.toCalendar.length > 0) {
                fromTimeStamp = new Date(this.state.fromCalendar)
                fromTimeStamp = (new Intl.DateTimeFormat(['ban', 'id'], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(fromTimeStamp).toString().substring(0, 10));
                toTimeStamp = new Date(this.state.toCalendar)
                toTimeStamp = (new Intl.DateTimeFormat(['ban', 'id'], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(toTimeStamp).toString().substring(0, 10));
            }
            console.log("tfeepost1",this.state.transactionFeesData);
            if (this.handleValidation()) {
                ApiCall(
                    'POST',
                    serviceBaseURL + TRANSACTIONFEES_ENDPOINT,
                    {
                        "feesList": [
                          {
                            "amountExVat": this.state.AmountExcludingVAT,
                            "amountInVat": ((Number(this.state.AmountExcludingVAT) + (this.state.AmountExcludingVAT * this.state.vatRate / 100)).toFixed(2)),
                            "effectiveDate": fromTimeStamp,
                            "expiryDate": toTimeStamp,
                            "feesType": "Regular",
                            "status": "Active",
                            "transFeesId": 0
                          }
                        ],
                        "service": this.state.transactionFeesData[0].service,
                        "serviceId": this.state.transactionFeesData[0].serviceId,
                        "vatRate": this.state.vatRate
                      },
                    {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'x-cc-trace-id': '1234',

                    }
                ).then(data => {
                    if (data.flag !== -1) {
                        if (data.flag === 500) {
                            if (data.data.message === "Time period Overlapping") {
                                this.setState({ hasOpenAlert: true })
                            }
                            else {
                                toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                            }
                        }
                        else {
                            console.log('I am 200!');
                            this.setState({ confirmedHasOpen: true });
                        }
                    }
                    else {
                        // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
                    }
                })
            }
        }
    }
    onCloseAlert = () => {
        this.setState({ hasOpenAlert: false })
    }
    onCloseConfirmed = () => {
        this.setState({ confirmedHasOpen: false });
        window.location.reload();
    }
    toggleEditDefaultAmount = () => {
        this.setState({ defaultAmountEdit: !this.state.defaultAmountEdit })
    }
    onCloseDeleteModal = () => {
        this.setState({ hasOpenDelete: false });
    }
    toggleActveTransactionFees = () => {
        this.setState({ showTransactionFeesActive: false })
        document.getElementById('ActveTransactionFees').style.borderBottom = "3px solid #857A71";
        document.getElementById('ExpiredTransactionFees').style.borderBottom = "none";
        document.getElementById('ExpiredTransactionFees').style.paddingBottom = "14px";
        document.getElementById('ActveTransactionFees').style.paddingBottom = "11px";
    }
    toggleExpiredTransactionFees = () => {
        this.setState({ showTransactionFeesActive: true })
        document.getElementById('ExpiredTransactionFees').style.borderBottom = "3px solid #857A71";
        document.getElementById('ActveTransactionFees').style.borderBottom = "none";
        document.getElementById('ActveTransactionFees').style.paddingBottom = "14px";
        document.getElementById('ExpiredTransactionFees').style.paddingBottom = "11px";
    }
    renderTableHeader() {
        return (
            <>
                <tr class="bg-white" id="tableHeader">
                    <td id="transactionFeescol1Heading" className="tansactionTableHeading">Effective Date</td>
                    <td id="transactionFeescol2Heading" className="tansactionTableHeading">Expiry Date</td>
                    <td id="transactionFeescol3Heading" className="tansactionTableHeading">
                        <small id="transactionheadAmountpre">Amount per container <samall id="transactionheadAmountpreR">R</samall></small>
                        <small id="transactionheadAmountpost">(Excluding VAT)</small>
                    </td>
                    <td id="transactionFeescol4Heading" className="tansactionTableHeading">
                        <small id="transactionheadAmountpre">Amount per container <samall id="transactionheadAmountpreR">R</samall></small>
                        <small id="transactionheadAmountpost">(Including VAT @{this.state.vatRate}%)</small>
                    </td>
                    <td className="tansactionTableHeading" style={{ display: !viewOnly ? "none" : null }}></td>
                </tr>
            </>
        )
    }
    renderExpiredAmountTableHeader() {
        return (
            <>
                <tr class="bg-white" id="tableHeader">
                    <td id="transactionExpiredFeescol1Heading" className="tansactionTableHeading">Effective Date</td>
                    <td id="transactionExpiredFeescol2Heading" className="tansactionTableHeading">Expiry Date</td>
                    <td id="transactionExpiredFeescol3Heading" className="tansactionTableHeading">
                        <small id="transactionheadAmountpre">Amount per container <samall id="transactionheadAmountpreR">R</samall></small>
                        <small id="transactionheadAmountpost">(Excluding VAT)</small>
                    </td>
                    <td id="transactionExpiredFeescol4Heading" className="tansactionTableHeading">
                        <small id="transactionheadAmountpre">Amount per container <samall id="transactionheadAmountpreR">R</samall></small>
                        <small id="transactionheadAmountpost">(Including VAT @{this.state.vatRate}%)</small>
                    </td>
                </tr>
            </>
        )
    }
    getDate = (dateString) => {
        //   split the date in order to get day, month and year separately and then use it in another constructor - Date(year, month, day)
        let dateParts = dateString.split("/");
        // month is 0-based, that's why we need dataParts[1] - 1
        let date = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]).toString();
        let day = date.split(' ')[2];
        let month = date.split(' ')[1];
        let year = date.split(' ')[3];
        return `${day}-${month}-${year}`;
    }
    onDeleteTransactionFee = (index) => {
        console.log("delete index", index);
        this.setState({
            hasOpenDelete: true,
            deleteIndex: index
        });
    }
    confirmDelete = (index) => {
        // console.log(index, "index", this.state.transactionFeesData.feesList[this.state.deleteIndex])
        ApiCall(
            'DELETE',
            serviceBaseURL + TRANSACTIONFEES_ENDPOINT,
            {
                "feesList": [
                    this.state.feesListData[this.state.deleteIndex]
                ],
                "service": this.state.transactionFeesData[0].service,
                "serviceId": this.state.transactionFeesData[0].serviceId,
                "vatRate": this.state.transactionFeesData[0].vatRate
              },
            // {
            //     "amountExVat": this.state.transactionFeesData.amountExVat,
            //     "amountInVat": this.state.transactionFeesData.amountInVat,
            //     "feesList": [
            //         this.state.transactionFeesData.feesList[this.state.deleteIndex]
            //     ],
            //     "service": this.state.transactionFeesData.service,
            //     "vatRate": this.state.transactionFeesData.vatRate
            // },
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                ' x-cc-trace-id': '1234',
            },
        ).then((apiData) => {
            if (apiData.flag !== -1) {
                if (apiData.flag === 500) {
                    toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                }
                else {
                    console.log('I am 200!');
                    console.log(apiData.message);
                    this.setState({
                        hasOpenDelete: false,
                        confirmedHasOpen: true
                    });
                }
            } else {
                // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }
        });
    }
    // componentDidUpdate() {
    //     this.transactionData = this.state.transactionFeesData;
    // }
    
    render() {
        const renderTableData = this.state.feesListData?.map((todo, index) => {
            return ((todo.status === "Active" && todo.feesType !== "Default") && 
                <>
                    {(!this.state.isEdit[index]) ?
                        <tr key={index} id="transactionFeesData">

                            <td id="transactionFeesfunctionNamecol1" className="transactionFeestabletabledata">
                                {this.getDate(todo.effectiveDate)}
                            </td>
                            <td id="transactionFeesfunctionNamecol2" className="transactionFeestabletabledata">{this.getDate(todo.expiryDate)}</td>
                            <td id="transactionFeesfunctionNamecol3" className="transactionFeestabletabledata">{todo.amountExVat}</td>
                            <td id="transactionFeesfunctionNamecol4" className="transactionFeestabletabledata">{todo.amountInVat
                            }</td>
                            <td id="transactionFeesfunctionNamecol5" style={{ display: !viewOnly ? "none" : null }}>
                                <div class="transactionFeesmainFunctionCol" >
                                    <img
                                        id="transectionEditImagecss"
                                        src={(this.state.isEdit[index]) ? require('../../../assets/images/editenable.svg') : require('../../../assets/images/edit.svg')}
                                        width="26" height="26" loading="lazy"
                                        class="transactionFeeseditimagetablefuntion" alt=""
                                        onClick={() => {
                                            let a = this.state.isEdit;
                                            a[index] = !this.state.isEdit[index];
                                            let x = [...this.state.editableIndex];
                                            x.push(index)
                                            this.setState({ isEdit: a, editableIndex: x });
                                        }}
                                    />
                                    <img
                                        src={require('../../../assets/images/delete_enable.svg')}
                                        width="26" height="26" alt="" loading="lazy"
                                        class="transactionFeeseditimagetablefuntion"
                                        onClick={() => this.onDeleteTransactionFee(index)}
                                    />
                                </div>
                            </td>
                        </tr>
                        :
                        <tr className="transactionFeesaddFunctionRow"
                            id="transactionFeesData"
                        >
                            <td id="transactionFeesfunctionNamecol1">
                                <div className="transactionFeesactiveDatetinput">
                                    <div class="transactionFeesCalendarInputBox">
                                        <input class="transactionFeesactiveDateInput" placeholder="Select Date"
                                            value={this.getDate(todo.effectiveDate)}
                                        ></input>
                                    </div>
                                    <div class="transactionFeescalendar">  {this.state.showEditFromCalendar[index] ? <div ref={this.container}> <Calendar
                                        onChange={(e) => {
                                            let formatted_date = e.getDate() + "/" + [e.getMonth() + 1] + "/" + e.getFullYear();
                                            if (e.getDate() <= 9) {
                                                formatted_date = "0" + formatted_date;
                                            }
                                            this.state.feesListData[index].effectiveDate = formatted_date;
                                            let showCalenderone = this.state.showEditFromCalendar;
                                            showCalenderone[index] = false;
                                            this.setState({
                                                showEditFromCalendar: showCalenderone,
                                                transactionFeesData: this.state.feesListData
                                            })
                                        }}
                                        minDate={new Date()} /></div> : null}</div>
                                    <img src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block mr-1 " alt="" loading="lazy"
                                        onClick={() => {
                                            let a = this.state.showEditFromCalendar;
                                            a[index] = true
                                            let x = [...this.state.editableIndex];
                                            x.push(index)
                                            this.setState({ showEditFromCalendar: a, editIndex: index, editableIndex: x })
                                        }}
                                    />
                                </div>
                            </td>
                            <td id="transactionFeesfunctionNamecol2">
                                <div className="transactionFeesactiveDatetinput">
                                    <div class="transactionFeesCalendarInputBox">
                                        <input class="transactionFeesactiveDateInput" placeholder="Select Date"
                                            value={this.getDate(todo.expiryDate)}
                                        ></input>
                                    </div>
                                    <div class="transactionFeescalendar" id="transactionFeesexpiryDateCalendar">  {this.state.showEditToCalendar[index] ? <div ref={this.container}> <Calendar
                                        onChange={(e) => {
                                            let formatted_date = e.getDate() + "/" + [e.getMonth() + 1] + "/" + e.getFullYear();
                                            if (e.getDate() <= 9) {
                                                formatted_date = "0" + formatted_date;
                                            }
                                            this.state.feesListData[index].expiryDate = (formatted_date);
                                            let showCalenderone = this.state.showEditToCalendar;
                                            showCalenderone[index] = false;
                                            this.setState({
                                                showEditToCalendar: showCalenderone,
                                                transactionFeesData: this.state.feesListData
                                            })
                                        }}
                                        minDate={
                                            new Date() >
                                                new Date(todo.effectiveDate.split("/")[2], todo.effectiveDate.split("/")[1] - 1, todo.effectiveDate.split("/")[0]) ? new Date() : new Date(todo.effectiveDate.split("/")[2], todo.effectiveDate.split("/")[1] - 1, todo.effectiveDate.split("/")[0])
                                        }
                                    /></div> : null}</div>
                                    <img src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block mr-1 " alt="" loading="lazy"
                                        onClick={() => {
                                            let a = this.state.showEditToCalendar;
                                            a[index] = true;
                                            let x = [...this.state.editableIndex];
                                            x.push(index)
                                            this.setState({ showEditToCalendar: a, editIndex: index, editableIndex: x })
                                        }}
                                    />
                                </div>
                            </td>
                            <td className="coltextAlignRight" id="transactionFeesfunctionNamecol3">
                                <input id="transactionFeesfunctionname" className="tabledata"
                                    value={todo.amountExVat}
                                    onChange={(e) => {
                                        let value = e.target.value;
                                        value = value.replace(/[^0-9\.]/gi, "");
                                        this.state.feesListData[index].amountExVat = value;
                                        this.state.feesListData[index].amountInVat = (Number(value) + (value * this.state.vatRate / 100)).toFixed(2)
                                        this.setState({ transactionFeesData: this.state.feesListData })
                                    }}
                                >
                                </input>
                            </td>
                            <td className="coltextAlignRight" id="transactionFeesfunctionNamecol4" >
                                <input id="transactionFeesdisplayname" className="tabledata"
                                    value={(Number(todo.amountExVat) + (todo.amountExVat * this.state.vatRate / 100)).toFixed(2)}
                                    readOnly
                                >
                                </input>
                            </td>
                            <td class="transactionFeesEditCol" id="transactionFeeseditcoltest">
                                <div class="transactionFeesmainFunctionCol">
                                    <img
                                        id="transectionEditImagecss"
                                        src={(this.state.isEdit[index]) ? require('../../../assets/images/cross.svg') : require('../../../assets/images/edit.svg')}
                                        width="26" height="26" alt="" loading="lazy"
                                        class="transactionFeeseditimagetablefuntion"
                                        onClick={() => {
                                            let a = this.state.isEdit;
                                            a[index] = !this.state.isEdit[index];
                                            this.setState({ isEdit: a });
                                        }}
                                    />
                                    <img
                                        src={(this.state.isDelete[index]) ? require('../../../assets/images/delete_enable.svg') : require('../../../assets/images/delete_disable.svg')}
                                        width="26" height="26" alt="" loading="lazy"
                                        class="transactionFeeseditimagetablefuntion"
                                        onClick={() => {
                                            let a = this.state.isDelete;
                                            a[index] = !this.state.isDelete[index];
                                            this.setState({ isDelete: a });
                                        }}
                                    />
                                </div>
                            </td>
                        </tr>}
                </>
            )
        });
       const renderExpiredAmountTableData = this.state.feesListData?.map((todo, index) => {
            return ((todo.status === "Expired" && todo.feesType !== "Default") &&
                <>
                    <tr id="transactionFeesData">
                        <td id="transactionExpiredFeesfunctionNamecol1" className="transactionFeestabletabledata">
                            {this.getDate(todo.effectiveDate)}
                        </td>
                        <td id="transactionExpiredFeesfunctionNamecol2" className="transactionFeestabletabledata">{this.getDate(todo.expiryDate)}</td>
                        <td id="transactionExpiredFeesfunctionNamecol3" className="transactionFeestabletabledata">{todo.amountExVat}</td>
                        <td id="transactionExpiredFeesfunctionNamecol4" className="transactionFeestabletabledata">{todo.amountInVat
                        }</td>
                    </tr>
                </>
            )
        });
        return (
            <div className="outer1"><div className="outer1" id="outerdiv">
                <MetaDecorator title={TitleDescription.transactionFeesPageTitle} description={TitleDescription.transactionFeesPageDescription} />
                <div className="transactionFeesFunctionContainer" >
                    <SideNav />
                    <div id="transactionFeesPart">
                        <div class="transactionFeesHeadingDiv">
                            <h1 id='transactionFeesHeadingTitle'>Transaction Fees</h1>
                            <div class="transectionuprightdiv">
                                <div class="transactionFeesdefaultAmtDropDiv">
                                    <input class="transactionFeesUpSearchInputBox" readOnly placeholder="- - Select Service Type - -" value={this.state.serviceTypeValue} />
                                    <img src={this.state.serviceTypeDropdown ? require('../../../assets/images/arrow-up.svg') : require('../../../assets/images/drpdwnArrow.svg')} onClick={this.toggleServiceTypeDropdown} width="14" height="14" class="d-inline-block ml-2 mt-2" alt="" loading="lazy" />
                                </div>
                                {this.state.serviceTypeDropdown && (
                                    <div class="caaad08raise" >
                                        <div class="caadropdowncardraise" ref={this.container} >
                                            {(this.state.serviceTypeData.map((Servicetypedata, index) => {
                                                return (
                                                    <table class='caaad09raise' key={index} onClick={(index1) => this.changeServiceType(index1)} >
                                                        <td class="caatt1raise" >
                                                            <small id="caatt2raise" >{Servicetypedata.service} </small>
                                                        </td>
                                                    </table>
                                                );
                                            }))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        {/* View Only Access */}
                        <div className="viewOnlyDiv" style={{ display: !viewOnly ? null : "none" }}>
                            <img alt="View Only Access" src={viewAccess} />
                            <span className="viewOnly">View Only Access</span>
                        </div>
                        <div className="transactionFeescontentbox" id="transactionFees">
                            <div class="servicesTypeUpDiv">
                                <div class="servicesTypeUpinDivleft">
                                    <div class="servicesTypeUpActiveDiv" id="ActveTransactionFees" onClick={this.toggleActveTransactionFees}>
                                        <small class="servicesTypeUpActiveDivText">Active</small>
                                    </div>
                                    <div class="servicesTypeUpExpiredDiv" id="ExpiredTransactionFees" onClick={this.toggleExpiredTransactionFees}>
                                        <small class="servicesTypeUpActiveDivText">Expired</small>
                                    </div>
                                </div>
                                <div class="servicesTypeUpinDivright">
                                    <div class="servicesTypeUpinDivrightin">
                                        <div class="servicesTypeSmallUp">
                                            <small class="servicesTypeSmallAmount">Default Amount per container* </small>
                                            <small class="servicesTypeSmallVat">(Excluding VAT)</small>
                                            <small class="servicesTypeSmallR">R</small>
                                        </div>
                                        <div class="servicesTypeUpinDivrightinput">
                                            <input class="transactionServicesInputBox" onChange={this.handleDefaultExcludingVATAmount} readOnly={!this.state.defaultAmountEdit ? true : false} placeholder="" 
                                            value={this.state.ExcludingVAT}
                                            style={{ borderBottom: !this.state.defaultAmountEdit && "none" }} />
                                            <img id="defaultAmountImage" onClick={this.toggleEditDefaultAmount} src={this.state.defaultAmountEdit ? require('../../../assets/images/cross.svg') : require('../../../assets/images/edit.svg')} width="16" height="16" class="ml-2 mt-2" alt="" loading="lazy"
                                                style={{ display: !viewOnly ? "none" : null }}
                                            />
                                        </div>
                                    </div>
                                    <div class="servicesTypeUpinDivrightin">
                                        <div class="servicesTypeSmallDown">
                                            <small class="servicesTypeSmallVat">(Including VAT @{this.state.vatRate}%)</small>
                                            <small class="servicesTypeSmallR">R</small>
                                        </div>
                                        <div class="servicesTypeUpinDivrightinput">
                                            <input class="transactionServicesInputBoxInclude" placeholder="" value={(Number(this.state.ExcludingVAT) + (this.state.ExcludingVAT * this.state.vatRate / 100)).toFixed(2)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {!this.state.showTransactionFeesActive &&
                                <table className="tableHeaderContainer">
                                    <tbody>
                                        {this.renderTableHeader()}
                                    </tbody>
                                </table>
                            }
                            {!this.state.showTransactionFeesActive &&
                                <>
                                    <div id="transactionFeesFunctionTable">
                                        <table id='transactionFeesdetails'>
                                            <tbody>
                                                {this.state.addNewRow === true &&
                                                    <tr
                                                        id="transactionFeesData"
                                                    >
                                                        <td>
                                                            <div className="transactionFeesactiveDatetinput">
                                                                <div class="transactionFeesCalendarInputBox">
                                                                    <input class="transactionFeesactiveDateInput" placeholder="Select Date"

                                                                        value={this.state.fromCalendar}
                                                                    ></input>
                                                                </div>
                                                                <div class="transactionFeescalendar">  {this.state.showFromCalendar ? <div ref={this.container}> <Calendar onChange={this.handleAddFromDateChanged} value={this.calenderone} minDate={new Date()} /></div> : null}</div>
                                                                <img src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block mr-1 " alt="" loading="lazy" onClick={this.toggleFromCalendar}
                                                                />
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="transactionFeesactiveDatetinput">
                                                                <div class="transactionFeesCalendarInputBox">
                                                                    <input class="transactionFeesactiveDateInput" placeholder="Select Date"
                                                                        value={this.state.toCalendar}
                                                                    ></input>
                                                                </div>
                                                                <div class="transactionFeescalendar" id="transactionFeesexpiryDateCalendar">  {this.state.showToCalendar ? <div ref={this.container}> <Calendar onChange={this.handleAddToDateChanged} value={this.calenderone} minDate={new Date(this.state.fromCalendar)} /></div> : null}</div>
                                                                <img src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block mr-1 " alt="" loading="lazy" onClick={this.toggleToCalendar}
                                                                />
                                                            </div>
                                                        </td>
                                                        <td className="coltextAlignRight">
                                                            <input id="transactionFeesfunctionname" className="tabledata" type="text" value={this.state.AmountExcludingVAT} onChange={this.handleAmountExcludingVAT}>
                                                            </input>
                                                        </td>
                                                        <td className="coltextAlignRight">
                                                            <input id="transactionFeesdisplayname" className="tabledata" type="text" value={(this.state.AmountExcludingVAT) ? ((Number(this.state.AmountExcludingVAT) + (this.state.AmountExcludingVAT * this.state.vatRate / 100)).toFixed(2)) : ""}>
                                                            </input>
                                                        </td>
                                                        <td class="transactionFeesEditCol" id="transactionFeeseditcoltest">
                                                            <div class="transactionFeesmainFunctionCol">
                                                                <img id="transectionEditImagecss" class="transactionFeeseditimagetablefuntion" src={require('../../../assets/images/edit.svg')} width="" height="" alt="" loading="lazy"
                                                                />
                                                                <img class="transactionFeeseditimagetablefuntion" src={require('../../../assets/images/delete_enable.svg')} width="" height="" alt="" loading="lazy"
                                                                    onClick={() =>
                                                                        this.setState({
                                                                            addNewRow: false,
                                                                            fromCalendar: '',
                                                                            toCalendar: '',
                                                                            AmountExcludingVAT: ''
                                                                        })
                                                                    }
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                }
                                                {renderTableData}
                                            </tbody>
                                        </table>
                                    </div>
                                    <hr width="100%" color="#BCBCBC" />
                                    <div id="transactionFeestableFooter" style={{ display: !viewOnly ? "none" : null }}>
                                        <Link onClick={this.onAddNewRow}
                                        ><img src={this.state.addNewRow ? addDisable : add} alt="" width="19" height="19" id="transactionFeesaddrole" /> <small className="transactionFeesaddFunctionText" style={{ color: this.state.addNewRow ? "#B6B6B6" : "#428BCA" }}>Add New Row</small></Link>
                                        <div class="transactionFeesfunctionbtndiv">
                                            <button
                                                disabled={!this.validateFormFields()}
                                                class={"transactionFeesconfirmfunctionbtn"} onClick={this.onConfirmTransactionFees}>Confirm</button>
                                        </div>
                                    </div>
                                    <div class="servicesTypeDefaultAmountDiv">
                                        <small class="servicesTypeDefaultAmount">* Default amount will be charged if no amount is mentioned under ‘Active’ tab.</small>
                                    </div>
                                </>}
                            {this.state.showTransactionFeesActive &&
                                <table className="tableHeaderContainer">
                                    <tbody>
                                        {this.renderExpiredAmountTableHeader()}
                                    </tbody>
                                </table>
                            }
                            {this.state.showTransactionFeesActive &&
                                <>
                                    <div id="transactionExpireyFeesFunctionTable">
                                        <table id='transactionFeesdetails'>
                                            <tbody>
                                                {renderExpiredAmountTableData}
                                            </tbody>
                                        </table>
                                    </div>
                                    <hr width="100%" color="#BCBCBC" />
                                    <div class="servicesTypeDefaultExpireyAmountDiv">
                                        <small class="servicesTypeDefaultAmount">* Default amount will be charged if no amount is mentioned under ‘Active’ tab.</small>
                                    </div>
                                </>}
                        </div>
                    </div>
                </div>
                <AlertModal onClick={this.onCloseAlert} hasOpen={this.state.hasOpenAlert} >
                    <div className="TransactionAddalertSectionTextContainer">
                        <small className="TransactionAddalertSectionText">Date ranges cannot overlap.</small>
                        <small className="TransactionAddalertSectionBoldText">Please select different date range.</small>
                    </div>
                </AlertModal>
                <SuccessModal hasOpen={this.state.confirmedHasOpen} onClick={this.onCloseConfirmed}>
                    <p className="confirmedText">Confirmed</p>
                </SuccessModal>
                <DeleteModal hasOpen={this.state.hasOpenDelete} onClick={this.onCloseDeleteModal} onYesClick={this.confirmDelete} >
                    <p className="deletemodalText">Do you really want to delete this transaction fee?</p>
                </DeleteModal>
            </div></div >
        )
    }
}
function mapStateToProps(state) {
    return {
        data: state.adminRoleReducer.roleData,
        serviceType: state.serviceTypeReducer.serviceType
    }
}
export default connect(mapStateToProps)(ServiceType);